import { GameVer } from '~/util/Lang';
import { getHpRate } from '~/util/npc';
import { Icon16 } from '../ui/Icon';

export function NpcHpRate(props: {
  skills: {
    id: number;
    skillName: string;
    level: number | null;
    name: string;
    icon: string;
  }[];
  game: GameVer;
}) {
  const rate = getHpRate(props.skills, props.game);
  return rate && <Icon16 icon={rate.icon} alt={rate.name} />;
}